import React, {Component} from 'react';
import ChartistGraph from 'react-chartist';
import {Grid, Row, Col, Table} from 'react-bootstrap';
import moment from 'moment';
import 'moment-timezone';
import Moment from 'react-moment';

import {Card} from 'components/Card/Card.jsx';
import {StatsCard} from 'components/StatsCard/StatsCard.jsx';
import {
    responsiveSales,
} from 'variables/Variables.jsx';

class Payment extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillReceiveProps(nextProps) {
    }

    componentWillMount() {
    }


    render() {
        return (
            <div className="content">
                <Card
                    title="Yerd.ly Payments"
                    category="Handled by Stripe"
                    lg={6} md={6} sm={6}
                    content={
                        <div>
                            <p>
                                <b>Yerd.ly</b> uses <b>Stripe</b> to handle credit cards. Stripe is also used and
                                trusted by big companies that you've heard of, such
                                as <b>Lyft</b> and <b>Kickstarter</b>. With <b>Stripe</b>, credit card payments go
                                straight to your account, with a fees witheld for credit card processing and for
                                the <b>Yerd.ly</b> platform.
                            </p>

                            <h4>Maximum Security</h4>
                            <p>
                                Since we rely on Stripe, we at Yerd.ly will never handle your money directly -- the
                                payments go straight to you. We never have your bank account details, nor the credit
                                card details of your customers. They all go straight to Stripe and are never saved on
                                our server.
                            </p>

                            <h4>Getting Started</h4>
                            <p>
                                To set up payments, you'll need to set up your own account with Stripe. They will handle
                                linking with your bank account and scheduling when you'd like to have your revenue
                                transferred to that account.
                            </p>

                        </div>
                    }>

                </Card>
            </div>
        );
    }
}

export default Payment;



// WEBPACK FOOTER //
// ./src/views/Payment/Payment.jsx